import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DefaultBadge from './DefaultBadge';

const SimulationTile = ({ row, theme, formatDate, formatTime, formatDuration }) => {
  const navigate = useNavigate();

  return (
    <Box
      key={row.id}
      onClick={() => navigate(`/dashboard/feedback/${row.id}`)}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        p: `${theme.customSpacing.xl} ${theme.customSpacing['3xl']}`,
        borderTop: `1px solid ${theme.palette.border.tertiary}`,
        borderBottom: `1px solid ${theme.palette.border.tertiary}`,
        color: theme.palette.text.tertiary,
        alignItems: 'center',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: theme.palette.background.brand_alt,
          borderColor: theme.palette.background.button_primary,
          color: theme.palette.text.primary,
        },
        '&:hover .hover-target': {
          color: theme.palette.background.button_primary,
        },
        '&:hover .hover-sub': {
          color: theme.palette.text.primary,
        },
        '&:hover .hover-badge': {
          borderColor: theme.palette.background.button_primary,
        },
      }}
    >
      <Box sx={{ width: '50%' }}>
        <Typography
          className="hover-target"
          sx={{
            fontWeight: theme.typography.fontWeightRegular,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: theme.palette.text.primary,
            fontSize: theme.typography.textSM.fontSize,
          }}
        >
          {row.scenario?.name || 'Unknown Simulation Challenge'}
        </Typography>
        <Typography
          className="hover-sub"
          sx={{
            fontWeight: theme.typography.fontWeightLight,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: theme.palette.text.disabled,
            fontSize: theme.typography.textSM.fontSize,
          }}
        >
          {row.scenario?.short_description || 'Unknown Simulation Challenge'}
        </Typography>
      </Box>

      <Box sx={{ width: '12.5%' }}>
        <Typography sx={{
          fontSize: theme.typography.textXS.fontSize,
          display: 'flex',
          alignContent: 'center',
          justifyContent: 'center'
        }}>
          {row.evaluation?.total_score?.value ? (
            <DefaultBadge
              className="hover-badge"
              variant="pillTransparent"
              borderColor={theme.palette.border.brand}
              size="small"
            >
              {(parseFloat(row.evaluation.total_score.value).toFixed(2) / 10).toFixed(1) + '/10'}
            </DefaultBadge>
          ) : (
            <DefaultBadge size="small">N/A</DefaultBadge>
          )}
        </Typography>
      </Box>

      <Box sx={{ width: '12.5%' }}>
        <Typography sx={{
          fontSize: theme.typography.textXS.fontSize,
          textAlign: 'center'
        }}>
          {formatDate(row.ended_at)}
        </Typography>
      </Box>

      <Box sx={{ width: '12.5%' }}>
        <Typography sx={{
          fontSize: theme.typography.textXS.fontSize,
          textAlign: 'center'
        }}>
          {formatTime(row.ended_at)}
        </Typography>
      </Box>

      <Box sx={{ width: '12.5%' }}>
        <Typography sx={{
          fontSize: theme.typography.textXS.fontSize,
          textAlign: 'center'
        }}>
          {formatDuration(row.started_at, row.ended_at)}
        </Typography>
      </Box>
    </Box>
  );
};

export default SimulationTile;
